import template from "./index.html";
import "./index.less";
import { EVENT_LOGOUT } from "../../../constants";
import {
	FORM_EXPORT_QUEUE_FOR_CONFIG, 
	FORM_REPORTS_BY_ID,
	FORM_EXPORT_CREATE
} from "../../../routes";
import {
	CURSOR_DIRECTIONS, 
	FILTER_OPERATORS 
} from "../constants";
import moment from "moment";

function controller(
	$scope, 
	eventBus, 
	$logger, 
	api, 
	appState, 
	loadingService, 
	entityManager,
	$window
) {
	const ctrl = this;

	ctrl.$onDestroy = ctrl.handleClose;

	ctrl.$onInit = () => {
		eventBus.register(EVENT_LOGOUT, () => { ctrl.handleClose(); }, $scope);

		ctrl.formConfig = appState.forms.selected;
		ctrl.selectedConfig = ctrl.resolve.availableConfigs.find(c => c.Code === ctrl.resolve.selectedConfig);
		ctrl.entityLabel = entityManager.primaryFieldLabel;
		
		const primaryDateField = ctrl.formConfig.Fields.find(f => f.IsPrimary === true && f.Type.Code === "DATE");
		ctrl.dateLabel = primaryDateField.Name;
		ctrl.areAllReportsSelected = true;
		ctrl.areAllNegativesSelected = true;

		loadPendingReports();
	};

	ctrl.handleClose = () => {
		ctrl.modalInstance.close();
	};

	ctrl.handleSaveExport = () => {
		saveReport().then(() => ctrl.modalInstance.close());
	};

	ctrl.updateConfig = () => {
		loadPendingReports();
	};

	ctrl.selectAllReports = () => {
		ctrl.includedReports.forEach(r => r.isSelected = ctrl.areAllReportsSelected);
	};

	ctrl.toggleReportSelection = () => {
		ctrl.areAllReportsSelected = !ctrl.includedReports.some(r => r.isSelected !== true);
	};

	ctrl.selectAllNegatives = () => {
		ctrl.includedNegatives.forEach(r => r.isSelected = ctrl.areAllNegativesSelected);
	};

	ctrl.toggleNegativeSelection = () => {
		ctrl.areAllNegativesSelected = !ctrl.includedNegatives.some(r => r.isSelected !== true);
	};

	ctrl.viewReport = (reportId) => {
		$window.open(`/report?id=${reportId}`, "_blank");
	};

	async function saveReport() {
		const exportReports = ctrl.includedReports.filter(r => r.isSelected);
		const exportNegatives = ctrl.includedNegatives.filter(r => r.isSelected);

		const reports = exportReports.concat(exportNegatives);
		const exportLogReports = reports.map(r => ({ Report: { Id: r.Id } }));
		const exportLogRequest = {
			Reports: exportLogReports,
			Configuration: { Code: ctrl.selectedConfig.Code }
		};	

		const enqueue = api.post(FORM_EXPORT_CREATE(ctrl.formConfig.Id), exportLogRequest);

		const response = await loadingService.watch(enqueue);

		return response;
	}

	async function loadPendingReports() {
		const exportableReportsPromise = api.get(FORM_EXPORT_QUEUE_FOR_CONFIG(ctrl.formConfig.Id, ctrl.selectedConfig.Code))
			.then(exportableReportIds => {
				const ids = exportableReportIds.map(r => r.Id);
				const Filter = {
					Id: { [FILTER_OPERATORS.in.code]: ids }
				};
				const Cursor = {
					Count: ids.length,
					Direction: CURSOR_DIRECTIONS.forward.code
				};
				const request = {
					Filter, 
					Cursor
				};
				
				return api.post(FORM_REPORTS_BY_ID(ctrl.formConfig.Id), request);
			});

		const exportableReports = await loadingService.watch(exportableReportsPromise);

		const augmentedReports = (exportableReports.Items ?? [])
			.filter(r => r.IsDeleted !== true)
			.map(r => {
				const friendly = entityManager.getFriendlyForPrimaryId(r.EntityId);
				let primary = friendly;

				if(friendly.Entities !== undefined) {
					primary = friendly?.Entities?.find(e => e.Entity.Id === r.EntityId)?.Entity;
				}
				const thisEntity = { primary, friendly };
				
				return {
					...r,
					entity: thisEntity,
					isSelected: true
				};
			});

		ctrl.includedReports = augmentedReports.filter(r => r.IsNegative !== true);
		ctrl.includedNegatives = augmentedReports.filter(r => r.IsNegative === true)
			.map(r => {
				const periodIds = r.Periods.map(p => p.Id);
				const seasonPeriod = {};
				for(const season of ctrl.formConfig.Seasons) {
					const matchingPeriod = season.Periods.find(p => periodIds.indexOf(p.Id) > -1);
					if(matchingPeriod !== undefined) {
						seasonPeriod.season = season;
						seasonPeriod.period = matchingPeriod;
						
						break;
					}
				}

				const begin = moment(seasonPeriod.period.BeginInclusive).format("MM-DD-yyyy HH:mm");
				const end = moment(seasonPeriod.period.EndExclusive).format("MM-DD-yyyy HH:mm");
				const periodLabel = `${seasonPeriod.season.Code} - ${seasonPeriod.period.Name}`;
				const periodRange = `${begin} - ${end}`;

				return {
					...r,
					periodLabel, 
					periodRange
				};
			});
	}
}

export const createExportModal = angular
	.module("vesl.components.create-new-export", [])
	.component("createNewExport", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
